import {
  Box,
  BoxProps,
  Divider as MUIDivider,
  DividerProps as MUIDividerProps,
} from '@mui/material';

type DividerProps = {
  width?: BoxProps['width'];
  containerProps?: BoxProps;
} & MUIDividerProps;

export function Divider({
  width = 120,
  containerProps,
  ...props
}: DividerProps) {
  return (
    <Box width={width} alignSelf="center" {...containerProps}>
      <MUIDivider {...props} />
    </Box>
  );
}
